import React, { useId } from 'react';
import { Modal } from 'react-bootstrap';
import './NotificationModal.less';

const NotificationModal = ({ 
    show, 
    onHide,
    title = "Notification",
    message = "This is a notification message.",
    action = {
        label: "OK",
        onClick: () => {}
    }
}) => {
    // Names the dialog for assistive tech (it is announced by its title).
    const titleId = useId();
    return (
        <>
            <Modal show={show} centered size="sm" onHide={onHide} aria-labelledby={titleId}>
                <Modal.Header closeButton>
                    <Modal.Title id={titleId} className='notification-modal-title'>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{message}</p>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-dark" onClick={action.onClick}>{action.label}</button>
                    <button className="btn btn-light" onClick={onHide}>Close</button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default NotificationModal;